"use client";

import { useRef } from "react";
import Lightbox from "./Lightbox";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgRotate from "lightgallery/plugins/rotate";
import "lightgallery/css/lg-video.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-fullscreen.css";
import "lightgallery/css/lg-autoplay.css";
import "lightgallery/css/lg-rotate.css";

export default function LightboxGallery({
  wrapperClassName,
  children,
  selector
}: {
  wrapperClassName: string;
  children: React.ReactNode;
  selector?: string;
}) {
  const restoreFocusRef = useRef<HTMLElement | null>(null);

  return (
    <Lightbox
      plugins={[lgVideo, lgZoom, lgFullscreen, lgAutoplay, lgRotate]}
      elementClassNames={wrapperClassName}
      selector={selector}
      showCloseIcon={true}
      escKey={true}
      keyPress={true}
      closable={true}
      closeOnTap={true}
      trapFocus={true}
      hideScrollbar={true}
      onBeforeOpen={() => {
        restoreFocusRef.current = document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
      }}
      onAfterClose={() => {
        const restoreTarget = restoreFocusRef.current;
        restoreFocusRef.current = null;
        window.requestAnimationFrame(() => restoreTarget?.focus());
      }}
      hideBarsDelay={0}
      download={true}
      counter={true}
      controls={true}
      fullScreen={true}
      thumbnail={true}
      rotate={true}
      autoplay={true}
      progressBar={true}
      zoom={true}
      scale={0.5}
      rotateLeft={true}
      rotateRight={true}
      getCaptionFromTitleOrAlt={false}
      mobileSettings={{
        showCloseIcon: true,
        controls: true,
        download: true,
        counter: true
      }}
    >
      {children}
    </Lightbox>
  );
}
